import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type UtilityBillResultsDataQueryVariables = Types.Exact<{
  documentId: Types.Scalars['Int']
}>

export type UtilityBillResultsDataQuery = {
  __typename?: 'Query'
  customerDocument: {
    __typename?: 'CustomerDocument'
    utilityBillAnalysis?: {
      __typename?: 'UtilityBillAnalysisResult'
      outcome: Types.Outcome
      checks: {
        __typename?: 'Checks'
        deadlines: {
          __typename?: 'DeadlinesCheck'
          outcome: Types.Outcome
          context: {
            __typename?: 'DeadlinesContext'
            values: {
              __typename?: 'DeadlinesContextValues'
              issueDate?: string | null
              servicePeriodEnd?: string | null
              servicePeriodStart?: string | null
            }
          }
        }
        advancePayments: {
          __typename?: 'AdvancePaymentsCheck'
          outcome: Types.Outcome
          context: {
            __typename?: 'AdvancePaymentsContext'
            values: { __typename?: 'AdvancePaymentsContextValues'; advancePayment?: number | null }
          }
        }
        servicePeriod: {
          __typename?: 'ServicePeriodCheck'
          outcome: Types.Outcome
          context: {
            __typename?: 'ServicePeriodContext'
            values: {
              __typename?: 'ServicePeriodContextValues'
              servicePeriodStart?: string | null
              servicePeriodEnd?: string | null
            }
          }
        }
        invoiceItems: {
          __typename?: 'InvoiceItemsCheck'
          outcome: Types.Outcome
          children: Array<{
            __typename?: 'InvoiceItemCheck'
            outcome: string
            context: {
              __typename?: 'InvoiceItemContext'
              item: string
              category?: string | null
              amount?: number | null
              prediction?: Types.Prediction | null
              deviation?: Types.Deviation | null
              pricePerSqm?: number | null
              pricePerSqmBenchmark?: number | null
              increaseInPercent?: number | null
              distribution?: {
                __typename?: 'Distribution'
                key?: string | null
                isValid?: boolean | null
              } | null
            }
          }>
        }
        distributionFormula: {
          __typename?: 'DistributionFormulaCheck'
          outcome: Types.Outcome
          children: Array<{
            __typename?: 'DistributionFormulaChildren'
            outcome: Types.Outcome
            context: {
              __typename?: 'DistributionFormulaContext'
              category?: string | null
              item: string
              distributionKey: string
            }
          }>
        }
        benchmarkDeviations: {
          __typename?: 'BenchmarkDeviationsCheck'
          outcome: Types.Outcome
          children: Array<{
            __typename?: 'BenchmarkDeviationsChildren'
            outcome: Types.Outcome
            context: {
              __typename?: 'BenchmarkDeviationsContext'
              item: string
              amount?: number | null
              category?: string | null
              deviation?: Types.Deviation | null
              prediction?: Types.Prediction | null
              pricePerSqm?: number | null
              pricePerSqmBenchmark?: number | null
              increaseInPercent?: number | null
            }
          }>
        }
      }
    } | null
  }
}

export const UtilityBillResultsDataDocument = gql`
  query UtilityBillResultsData($documentId: Int!) {
    customerDocument(customerDocumentId: $documentId) {
      utilityBillAnalysis {
        outcome
        checks {
          deadlines {
            outcome
            context {
              values {
                issueDate
                servicePeriodEnd
                servicePeriodStart
              }
            }
          }
          advancePayments {
            outcome
            context {
              values {
                advancePayment
              }
            }
          }
          servicePeriod {
            outcome
            context {
              values {
                servicePeriodStart
                servicePeriodEnd
              }
            }
          }
          invoiceItems {
            outcome
            children {
              outcome
              context {
                item
                category
                amount
                prediction
                deviation
                distribution {
                  key
                  isValid
                }
                pricePerSqm
                pricePerSqmBenchmark
                increaseInPercent
              }
            }
          }
          distributionFormula {
            outcome
            children {
              outcome
              context {
                category
                item
                distributionKey
              }
            }
          }
          benchmarkDeviations {
            outcome
            children {
              outcome
              context {
                item
                amount
                category
                deviation
                prediction
                pricePerSqm
                pricePerSqmBenchmark
                increaseInPercent
              }
            }
          }
        }
      }
    }
  }
`
export function useUtilityBillResultsDataQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    UtilityBillResultsDataQuery,
    UtilityBillResultsDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    UtilityBillResultsDataQuery,
    UtilityBillResultsDataQueryVariables
  >(UtilityBillResultsDataDocument, options)
}
export function useUtilityBillResultsDataLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UtilityBillResultsDataQuery,
    UtilityBillResultsDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    UtilityBillResultsDataQuery,
    UtilityBillResultsDataQueryVariables
  >(UtilityBillResultsDataDocument, options)
}
export type UtilityBillResultsDataQueryHookResult = ReturnType<
  typeof useUtilityBillResultsDataQuery
>
export type UtilityBillResultsDataLazyQueryHookResult = ReturnType<
  typeof useUtilityBillResultsDataLazyQuery
>
export type UtilityBillResultsDataQueryResult = ApolloReactCommon.QueryResult<
  UtilityBillResultsDataQuery,
  UtilityBillResultsDataQueryVariables
>
export function refetchUtilityBillResultsDataQuery(
  variables?: UtilityBillResultsDataQueryVariables
) {
  return { query: UtilityBillResultsDataDocument, variables: variables }
}
